// @commedab/core — moteur d'estimation, modèle, catalogue, recherche.
// TypeScript pur, aucune dépendance. Toute fonction reçoit la date courante en paramètre.
// Voir docs/specs-techniques.md, sections 3, 4 et 7.

export * from './model';
export { InvalidInputError } from './errors';
export { addDays, addHours, dayOf, daysBetween } from './date';
export { packsFor, packUnits } from './quantity';
export {
  observedIntervals,
  PERIOD_DAYS,
  resolveRate,
  toDaysPerUnit,
  toPerPeriod,
  type Interval,
  type PerPeriod,
  type Rate,
  type RatePeriod,
} from './rate';
export { estimateStock, type StockEstimate } from './stock';
export { productState, type ProductState } from './state';
export { suggestForPeriod, type Justification, type Suggestion } from './suggest';
export {
  applyRecipe,
  missingIngredients,
  type MissingIngredient,
  type RecipeLine,
} from './recipes';
export {
  listView,
  SESSION_GAP_HOURS,
  shoppingSessions,
  type LineState,
  type ListView,
  type RecipeBadge,
  type ShoppingSession,
} from './session';
export { DEFAULT_PERIOD_DAYS, resolvePeriod, type Period } from './period';
export { normalizeName } from './normalize';
export { DEFAULT_CATEGORIES, type DefaultCategory, type SystemKey } from './categories';
export {
  CATALOG,
  CATALOG_VERSION,
  DEFAULT_UNIT_LABEL,
  parseCatalog,
  productDraft,
  type CatalogEntry,
  type ProductDraft,
} from './catalog';
export {
  productsByPurchases,
  search,
  type SearchableProduct,
  type SearchableRecipe,
  type SearchResult,
} from './search';
